<template>
  <div class="order-details">
    <Loader :loading="isLoading">
      <SfTabs :open-tab="1">
        <SfTab :title="$t('Order Details')">
          <div class="row">
            <div class="col-xs-12">
              <SfHeading
                class="sf-heading--left m-base"
                :level="3"
                :title="`${$t('Status')} #${order.OrderNumber}`"
              />
              <div class="m-base">
                <SfTable>
                  <SfTableHeading>
                    <SfTableHeader>
                      {{ $t('Created On') }}
                    </SfTableHeader>
                    <SfTableHeader>
                      {{ $t('Payment Status') }}
                    </SfTableHeader>
                    <SfTableHeader>
                      {{ $t('Shipping Status') }}
                    </SfTableHeader>
                    <SfTableHeader>
                      {{ $t('Order Status') }}
                    </SfTableHeader>
                  </SfTableHeading>
                  <SfTableRow>
                    <SfTableData>
                      {{ dateFormatter().format(new Date(order.CreatedOn)) }}
                    </SfTableData>
                    <SfTableData>
                      {{ order.PaymentMethodStatus }}
                    </SfTableData>
                    <SfTableData>
                      {{ order.ShippingStatus }}
                    </SfTableData>
                    <SfTableData>
                      {{ order.OrderStatus }}
                    </SfTableData>
                  </SfTableRow>
                </SfTable>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <SfHeading
                class="sf-heading--left m-base"
                :level="3"
                :title="$t('Shipping')"
              />
              <div>
                <SfHeading
                  class="sf-heading--left m-base"
                  :level="4"
                  :title="order.PickUpInStore
                    ? $t('Pickup Address')
                    : $t('Shipping Address')"
                />
                <Address :address="order.PickUpInStore
                  ? order.PickupAddress
                  : order.ShippingAddress"
                />
                <SfHeading
                  class="sf-heading--left m-base"
                  :level="4"
                  :title="$t('Shipping Method')"
                />
                <p>{{ order.ShippingMethod }}</p>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <SfHeading
                class="sf-heading--left m-base"
                :level="3"
                :title="$t('Billing')"
              />
              <div>
                <SfHeading
                  class="sf-heading--left m-base"
                  :level="4"
                  :title="$t('Billing Address')"
                />
                <Address :address="order.BillingAddress" />
                <SfHeading
                  class="sf-heading--left m-base"
                  :level="4"
                  :title="$t('Payment Method')"
                />
                <p>{{ order.PaymentMethod }}</p>
              </div>
            </div>
            <div class="col-xs-12">
              <SfHeading
                class="sf-heading--left m-base"
                :level="3"
                :title="$t('Products')"
              />
              <div class="m-base">
                <ProductTable :items="order.Items" />
              </div>
            </div>
            <div class="col-xs-12" v-if="order.OrderNotes && order.OrderNotes.length">
              <SfHeading
                class="sf-heading--left m-base"
                :level="3"
                :title="$t('Notes')"
              />
              <div class="m-base">
                <div class="notes">
                  <div class="note" v-for="note in order.OrderNotes" :key="note.Id">
                    <div class="note-date">
                      {{ dateFormatter().format(new Date(note.CreatedOn)) }}
                    </div>
                    <div class="note-text">{{ note.Note }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-md-offset-6">
              <SfHeading
                class="sf-heading--left m-base"
                :level="3"
                :title="$t('Totals')"
              />
              <div class="m-base">
                <Totals :totals="order" />
              </div>
            </div>
          </div>
        </SfTab>
      </SfTabs>
    </Loader>
  </div>
</template>

<script>
import { SfTable, SfTabs, SfHeading } from '@storefront-ui/vue';
import { Loader, config } from '@/modules/core';
import user from '../../mixins/user';
import Address from './addresses/Address.vue';
import ProductTable from './order-details/ProductsTable.vue';
import Totals from './order-details/Totals.vue';

export default {
  name: 'OrderHistory',
  mixins: [user, config],
  components: {
    SfTable,
    SfTabs,
    SfHeading,
    Loader,
    Address,
    ProductTable,
    Totals,
  },
  created() {
    const { id } = this.$route.params;
    this.fetchOrder(id)
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.$router.push({ name: 'OrderHistory' });
      });
  },
  data() {
    return {
      isLoading: true,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";

.m-base {
  margin-top: var(--spacer-xs);
  margin-bottom: var(--spacer-xs);
}

.notes {
  margin-bottom: 20px;
}

.note-date {
  font-weight: bold;
  margin-bottom: 15px;
}

</style>
